/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaBrandLogo/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2BrandLogo from 'DesignSystem/Svgs/Tysiav2BrandLogo/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaBrandLogo({
  children,
  viewPath = "/DesignSystem/TysiaBrandLogo"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaBrandLogo.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-16pIaK': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TysiaBrandLogo.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2BrandLogo
  viewPath={`${viewPath}/Tysiav2BrandLogo`}
 fill={dtColorsWhite}
/>
</div>
</div>
{children}
</React.Fragment>)
}